import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=52b3c8dc&scoped=true"
var script = {}
import style0 from "./Edit.vue?vue&type=style&index=0&id=52b3c8dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b3c8dc",
  null
  
)

export default component.exports